/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { FullProduct } from '@msdyn365-commerce/commerce-entities';
import { ProductList, ProductListLine } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import { IAlternateProductData } from '../../../../actions/get-alternate-items-collection.action';
import {IProductInventoryInformation} from '@msdyn365-commerce-modules/retail-actions';
import { IGCProductTradeAgreementsEntity } from '../../../../actions/AlternateItemsEntity.g';
export interface IFullProduct extends FullProduct {
    AlternateProduct?: IAlternateProductData;
    IsOversizedItem: boolean | undefined;
    IsAlternateOversized?: boolean;
    TradeAgreement?: IGCProductTradeAgreementsEntity;
}

/**
 * OrderTemplateLine state information.
 */
export class OrderTemplateLine {
    public productListLine: ProductListLine;

    public fullProduct?: IFullProduct;

    public error?: string;

    public shouldDisable?: boolean;
    
    public productAvailability?: IProductInventoryInformation[];
    
    constructor(productListLine: ProductListLine, fullProduct?: IFullProduct, error?: string, shouldDisable?: boolean) {
        this.productListLine = productListLine;
        this.fullProduct = fullProduct;
        this.error = error;
        this.shouldDisable = shouldDisable;
    }

}

export interface IOrderTemplateLinesState {
    lines: OrderTemplateLine[];
    totalCount: number;
}

/**
 * Order template class.
 */
export class OrderTemplate {
    public productList: ProductList;

    public orderTemplateLines: OrderTemplateLine[];

    public totalLines: number;

    constructor(productList: ProductList, orderTemplateLines: OrderTemplateLine[], totalLines: number) {
        this.productList = productList;
        this.orderTemplateLines = orderTemplateLines;
        this.totalLines = totalLines;
    }
}
